import { render } from "./NotificationsPartial.vue?vue&type=template&id=eb37ee98&scoped=true"
import script from "./NotificationsPartial.vue?vue&type=script&lang=js"
export * from "./NotificationsPartial.vue?vue&type=script&lang=js"

import "./NotificationsPartial.vue?vue&type=style&index=0&id=eb37ee98&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb37ee98"]])

export default __exports__